export default __webpack_public_path__ + "static/media/mydrugs.4081bddd.png";